<script>

    /* mobile menu */
    let showMobileMenu = false;
    const handleBurgerClick = () => (showMobileMenu = !showMobileMenu);

</script>

<nav class="navbar has-shadow">
    <div class="navbar-brand">
        <!-- Logo, navbar-burger -->
        <div class="navbar-search">
            
        </div>
        <h1 class="pdny-logo">Paolino <span>Development</span></h1>
        <div on:click={handleBurgerClick} class="navbar-burger">
            <span></span>
            <span></span>
            <span></span>
        </div>
    </div>
    <div class="navbar-menu">
        <!-- dropdown menu -->
        <div class="navbar-item">
            <div class="navbar-link is-arrowless">
                <a href="https://paolinodevelopmentny.com/property-listings/">Property Listings</a>
            </div>
            <div class="navbar-dropdown">
                <ul>
                    <li><a href="https://paolinodevelopmentny.com/property/374-pauls-lane/">374 Pauls Lane</a></li>
                    <li><a href="/property/1400-meadow-lane-southampton-ny/">1400 Meadow Ln</a></li>
                    <li><a href="/property/411-jobs-lane-southampton-ny/">411 Jobs Lane</a></li>
                    <li><a href="/property/100-south-pointe-drive-townhouse-2-3-miami-beach-fl">100 S Pointe Dr</a></li>
                    <li><a href="/property/104-halsey-lane-bridgehampton-ny">104 Halsey Lane</a></li>
                    <li><a href="/property/106-halsey-lane-bridgehampton-ny/">106 Halsey Lane</a></li>
                    <li><a href="/property/3730-wesley-avenue-ocean-city-nj">3730 Wesley Ave</a></li>
                    <li><a href="/property/3301-ne-1st-ave-lower-penthouse-miami-fl/">3301 NE 1st Ave</a></li>
                    <li><a href="/property/2626-delmar-drive-fort-lauderdale-fl">2626 Delmar Place</a></li>
                    <li><a href="/property/1000-crawford-place-mount-laurel-nj">1000 Crawford</a></li>
                    <li><a href="/property/500-east-mantua-avenue-wenonah-nj">500 E Mantua Ave</a></li>
                    <li><a href="/property/2455-del-lago-drive-fort-lauderdale-fl">2455 Del Lago</a></li>
                    <li><a href="/property/4-pheasant-close-west-southampton-ny">4 Pheasant Close</a></li>
                    <li><a href="/property/29-west-pond-drive-bridgehampton-ny">29 West Pond Dr</a></li>
                    <li><a href="/property/215-roses-grove-southampton-ny">215 Roses Grove</a></li>
                    <li><a href="/property/108-halsey-lane-bridgehampton-ny">108 Halsey Lane</a></li>
                </ul>
            </div>
        </div>
        <div class="navbar-item">
            <div class="navbar-link is-arrowless">
                <a href="#about">About Us</a> 
            </div>
            <div class="navbar-dropdown">
                <ul>
                    <li><a href="https://paolinodevelopmentny.com/about-us/louis-paolino-ceo/">CEO</a></li>
                    <li><a href="https://paolinodevelopmentny.com/about-us/cher-leann-luisi-cfo/">CFO</a></li>
                    <li><a href="https://paolinodevelopmentny.com/about-us/borgesarchitects/">Architect</a></li>
                </ul>
            </div>
        </div>
        <div class="navbar-item">
            <div class="navbar-link is-arrowless">
                <a href="https://paolinodevelopmentny.com/contact-us/">Contact Us</a>
            </div>
        </div>
    </div>
</nav>

<aside class={`navmenu${showMobileMenu ? ' mobile' : ''}`}>
    <ul>
        <li>
            <a href="https://paolinodevelopmentny.com/property-listings/">Property Listings</a> 
        </li>
        <li>
            <a href="https://paolinodevelopmentny.com/about-us/">About Us</a> 
        </li>
        <li>
            <a href="https://paolinodevelopmentny.com/contact-us/">Contact Us</a>
        </li>
    </ul>
</aside>

<style>
    .pdny-logo {
        font-size: 36px;
        text-align: center;
        padding-top: 18px;
        letter-spacing: 3px;
        line-height: 0.54;
        font-family: 'antic didone', serif;
        text-transform: uppercase;
    }
    .pdny-logo span {
        display: block;
        font-family: "Open Sans",sans-serif;
        font-size: 14px;
        letter-spacing: 5.1px;
        font-weight: normal;
        padding-top: 15px;
    }

    .navbar {
        flex-direction: row-reverse;
    }
    .navbar-burger {
        margin-top: 9px;
        margin-left: 0;
    }
    .navbar-brand {
        flex-direction: row-reverse;
        justify-content: space-between;
        height: 75px;
    }
    .navbar-search {
        width: 3.25rem;
    }
    
    /* top level menu */
    .is-arrowless {
        text-transform: uppercase;
        font-weight: 600;
        letter-spacing: .0875em;
    }
    .is-arrowless a {
        color: #888484;
        padding: 0 3px;
    }
    .is-arrowless a:hover {
        color: #1b1c21;
        transition: all 1s;
        background: #e9c763;
    }

    /* dropdown menu */
    .navbar-item:hover .navbar-dropdown {
        display: block;
    }
    .navbar-dropdown {
        font-size: 1rem;
        font-family: 'Antic Didone', serif;
        line-height: 2.1;
        font-weight: 600;
        padding: 18px;
        border: 0;
    }
    .navbar-dropdown a,
    aside.navmenu a {
        color: #aaa;
        letter-spacing: .03em;
        padding: 3px 6px;
    }
    .navbar-dropdown a:hover,
    aside.navmenu a:hover {
        background: #e9c763;
        transition: all 1s;
        color: #1b1c21;
    }

    /* mobile menu */
    aside.navmenu {
        font-family: 'Antic Didone', serif;
        z-index: 25;
        padding: 18px;
        line-height: 2.4;
        display: none;
        position: absolute;
        background: white;
        padding: 18px; 
    }
    .navmenu.mobile {display:block;}
    

    @media screen and (min-width: 1024px) {
        .navbar-search {
            display: none;
        }
        .navbar {
            flex-direction: row;
        }
        .navbar-brand {
            display: block;
            position: absolute;
            width: 100%;
            text-align:center;
        }
        .navbar-menu {
            justify-content: center;
            margin-top: 30px;
        }

        .pdny-logo,
        .pdny-logo span {
            font-size: 24px;
            padding-top: 18px;
            letter-spacing: 0.21em;
            line-height: 0.54;
            font-family: 'antic didone', serif;
            text-transform: uppercase;
        }
        .pdny-logo span {
            display: inline;
        }
        .navmenu.mobile {
            display: none;
        }
    }
</style>